function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M348.48,822.62H153.65a23.73,23.73,0,0,0-23.71,23.7v.28a23.74,23.74,0,0,0,23.72,23.61H348.48a23.8,23.8,0,1,0,0-47.59Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M218.34,502.53a23.11,23.11,0,0,0,16.29-7.18l113.94-114L462.45,495.3c.27.28.53.54.77.76a23.17,23.17,0,0,0,16.1,6.47h.53a23.3,23.3,0,0,0,15.62-40.1l-5.72-5.73,32-32,70.59,70.59c.21.22.42.43.77.76a23.31,23.31,0,0,0,32.19-33.71l-84-84.25a22,22,0,0,0-36.39-3.21,19.45,19.45,0,0,0-2.25,3.2L457,423.76l-89-89a23.39,23.39,0,0,0-2.41-3.36,25,25,0,0,0-34.08.2,21.73,21.73,0,0,0-2.23,3.17L201.76,462.35c-.29.27-.55.53-.77.77a23.33,23.33,0,0,0,.72,32.94A24,24,0,0,0,218.34,502.53Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M262,199.16H565.06a23.8,23.8,0,0,0,0-47.59H262a23.8,23.8,0,1,0,0,47.59Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M454.68,629.9a23.81,23.81,0,0,0,23.79,23.79H673.33a23.8,23.8,0,0,0,0-47.59H478.47A23.82,23.82,0,0,0,454.68,629.9Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M467.54,281.43a34.64,34.64,0,1,0,34.63,35.38l.1-.88a34.67,34.67,0,0,0-34.61-34.5Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M348.48,714.31H153.65a23.8,23.8,0,0,0,.09,47.59H348.48a23.8,23.8,0,1,0,0-47.59Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M954.6,324.6H805.22V23.71A23.73,23.73,0,0,0,781.52,0H45.41A23.74,23.74,0,0,0,21.7,23.71v866A110.48,110.48,0,0,0,132.05,1000H868.11A110.53,110.53,0,0,0,978.3,889.62V348.31A23.73,23.73,0,0,0,954.6,324.6Zm-23.68,47.73V889.62a62.8,62.8,0,0,1-125.59,0V372.33ZM777.75,952.41H132.07A62.86,62.86,0,0,1,69.3,889.62V47.51H757.74V889.62A110.25,110.25,0,0,0,777.75,952.41Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M673.33,714.35H478.47a23.8,23.8,0,1,0,0,47.59H673.33a23.8,23.8,0,1,0,0-47.59Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M348.7,606h-195a23.8,23.8,0,1,0,0,47.59H348.68a23.73,23.73,0,0,0,23.71-23.7v-.32A23.73,23.73,0,0,0,348.7,606Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M673.33,822.6H478.47a23.8,23.8,0,1,0,0,47.59H673.33a23.8,23.8,0,1,0,0-47.59Z"
});

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.40dfc0d9.svg";
export { ForwardRef as ReactComponent };